export enum DocumentType {
  CIF = 'CIF',
  NIF = 'NIF',
  PASSPORT = 'PASSPORT',
  NIE = 'NIE',
}
